import React, { memo } from 'react';
import * as styles from './Input.module.css';

const Input = ({ onChange, value, type, placeholder }) => (
  <div className={styles.Input}>
    <input
      type={type}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
    />
  </div>
);

export default memo(Input);
